export let env = process.env;

export function initConfigEnv(initEnv: NodeJS.ProcessEnv): void {
  env = initEnv;
}
